var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"fill":_vm.color,"fill-rule":"nonzero"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M4.317 3.978l-3.4 2.38A.583.583 0 0 1 0 5.88V1.12A.583.583 0 0 1 .918.642l3.4 2.38a.583.583 0 0 1 0 .956z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }